export default __webpack_public_path__ + "static/media/ic_cnote_24.7a98bde6.svg";